export default "__VITE_ASSET__DK$64FJZ__"